export default __webpack_public_path__ + "static/media/preview.be0983bd.svg";